import React from 'react';
import { FiCamera } from 'react-icons/fi';
import './SummaryCard.css';

const SummaryCard = ({ user, onScanOpen }) => {
  const pictureUrl = localStorage.getItem('line_picture_url');

  return (
    <div className="bts-summary" style={{ position: 'relative', overflow: 'hidden' }}>
      <div className="bts-summary__deco-circle" />

      <div className="bts-summary__top">
        <div>
          <p className="bts-summary__label">คะแนนรวม</p>
          <div className="bts-summary__points-row">
            <span className="bts-summary__points">
              {(user.totalPoints || 0).toLocaleString()}
            </span>
            <span className="bts-summary__points-unit">คะแนน</span>
          </div>
        </div>
        {/* Profile รูปจุดเดิม */}
        <div className="bts-summary__trophy-box">
          {pictureUrl ? (
            <img src={pictureUrl} alt="profile" className="bts-summary__profile-img" />
          ) : (
            <span style={{ fontSize: 24 }}>👤</span>
          )}
        </div>
      </div>

      <hr className="bts-summary__divider" />

      <div className="bts-summary__info-row">
        <div className="bts-summary__info-box">
          <p className="bts-summary__info-label">สแกนแล้ว</p>
          <p className="bts-summary__info-value">{user.billCount || 0} บิล</p>
        </div>
        <div className="bts-summary__info-box bts-summary__info-box--rank">
          <p className="bts-summary__info-label">อันดับทีม</p>
          <p className="bts-summary__info-value">{user.rank || '-'}</p>
        </div>
        <div className="bts-summary__info-box bts-summary__info-box--scan" onClick={onScanOpen}>
          <FiCamera size={22} color="#ffffff" strokeWidth={2.5} />
          <p className="bts-summary__info-label" style={{ color: '#ffffff' }}>สแกนบิล</p>
        </div>
      </div>

      {/* Pending = รอคำนวณ */}
      {user.pendingCount > 0 && (
        <div className="bts-summary__pending">
          📋 มี {user.pendingCount} บิลรอคำนวณ (รอสร้าง/เข้าร่วมทีม)
        </div>
      )}

      {/* Processed = เพิ่มคะแนนแล้ว */}
      {user.processedCount > 0 && user.pendingCount === 0 && user.billCount <= user.processedCount && (
        <div className="bts-summary__processed">
          ✅ บิลที่สแกนไว้ {user.processedCount} ใบ ได้เพิ่มคะแนนเข้าทีมแล้ว!
        </div>
      )}
    </div>
  );
};

export default SummaryCard;
